import { Component } from './cart-discount-component.js';

class DisclosureCustom extends Component {
  requiredRefs = ['disclosureTrigger', 'disclosureContent'];

  connectedCallback() {
    super.connectedCallback();
    this.syncDisclosureState();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  #setExpanded(expanded) {
    const { disclosureTrigger: trigger, disclosureContent: content } = this.refs;
    if (!trigger || !content) return;

    trigger.setAttribute('aria-expanded', String(expanded));
    trigger.setAttribute(
      'aria-label',
      expanded ? trigger.dataset.disclosureClose : trigger.dataset.disclosureOpen
    );

    content.classList.toggle('is-expanded', expanded);

    if (expanded) {
      content.removeAttribute('inert');
      content.inert = false;
      // Explicit px height as fallback when max-height/grid fail on WebKit
      requestAnimationFrame(() => {
        const inner = content.querySelector('.disclosure-content__inner') || content;
        const height = Math.max(inner.scrollHeight, 80);
        content.style.maxHeight = `${height}px`;
      });
    } else {
      content.style.maxHeight = '0px';
      content.setAttribute('inert', '');
      content.inert = true;
    }
  }

  toggleDisclosure = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const { disclosureTrigger: trigger } = this.refs;
    if (!trigger) return;

    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    this.#setExpanded(!expanded);
  };

  syncDisclosureState = () => {
    const { disclosureTrigger: trigger } = this.refs;
    if (!trigger) return;

    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    this.#setExpanded(expanded);
  };

  removeDiscountFromDisclosure = (event) => {
    if (!event || !event.target) return;

    event.preventDefault();
    event.stopPropagation();

    const button = event.target.closest('.disclosure-trigger__pill-remove');
    if (!button) return;

    const pill = button.closest('.disclosure-trigger__pill');
    if (!pill) return;

    const code = pill.getAttribute('data-discount-code');
    if (!code) return;

    const component = document.querySelector('cart-discount-component');
    if (component && typeof component.removeDiscountByCode === 'function') {
      component.removeDiscountByCode(code);
    }
  };
}

if (!customElements.get('disclosure-custom')) {
  customElements.define('disclosure-custom', DisclosureCustom);
}
